// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-show-border {\n  border: 1px solid #ccc;\n}\n", ""]);
// Exports
module.exports = exports;
